import { useState, useEffect } from 'react';

const SECTION_IDS = ['home', 'about', 'services', 'resume', 'work', 'contact'];
const TOP_OFFSET = 120;

export function useActiveSection(): string {
  const [activeId, setActiveId] = useState('home');

  useEffect(() => {
    function updateActive() {
      let current = SECTION_IDS[0];
      for (const id of SECTION_IDS) {
        const el = document.getElementById(id);
        if (!el) continue;
        const { top } = el.getBoundingClientRect();
        if (top <= TOP_OFFSET) current = id;
      }
      setActiveId(current);
    }

    updateActive();
    window.addEventListener('scroll', updateActive, { passive: true });
    return () => window.removeEventListener('scroll', updateActive);
  }, []);

  return activeId;
}
